import React__default from 'react';
import { jsx } from '@emotion/react';

function Page(_ref) {
  var children = _ref.children;
  return jsx(React__default.Fragment, null, children);
}

export { Page };
//# sourceMappingURL=Page.js.map
